module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BranchSelectorPPL":{"close":{"ariaLabel":"Zavřít výběr výdejního místa"}}},"de":{},"sk":{}}')
  delete Component.options._Ctor
}
